export const MESSAGE_PREVIEW_MAX = 55;

export function getMessagePreview(message, maxLen = MESSAGE_PREVIEW_MAX) {
  if (!message) return null;
  if (message.length <= maxLen) return message;
  return `${message.substring(0, maxLen)}...`;
}

export function isMessageTruncated(message, maxLen = MESSAGE_PREVIEW_MAX) {
  return Boolean(message && message.length > maxLen);
}
